import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

export class UserTimezoneOffsetInterceptor implements HttpInterceptor {
  readonly #offsetString: string;

  constructor() {
    this.#offsetString = this.#getTimezoneOffsetString();
  }

  intercept(req: HttpRequest<unknown>, handler: HttpHandler) {
    req = req.clone({
      setHeaders: {
        'X-TimeZone-Offset': this.#offsetString,
      },
    });

    return handler.handle(req);
  }

  #getTimezoneOffsetString(): string {
    const offsetInMinutes = new Date().getTimezoneOffset();
    const sign = offsetInMinutes > 0 ? '-' : '';
    const absOffset = Math.abs(offsetInMinutes);
    const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
    const minutes = String(absOffset % 60).padStart(2, '0');

    return `${sign}${hours}:${minutes}`;
  }
}
